export const NOTIFICATION_SET_UNREAD_NOTIFICATIONS = 'notificationSetUnreadNotifications'
export const NOTIFICATION_SET_READ_NOTIFICATIONS = 'notificationSetReadNotifications'
export const NOTIFICATION_SET_NOTIFICATION = 'notificationSetNotification'
export const NOTIFICATION_SET_UNREAD_COUNT = 'notificationSetUnreadCount'